import wrapRoot from './src/lib/wrap-root-element'
export const wrapRootElement = wrapRoot
